export const IconButtonSize = {
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
  ExtraLarge: 'xl',
} as const

export { ButtonVariant as IconButtonVariant } from '../abstract-button/helpers'
